export function determineBaseURL(app: string): string {
  const hostname = window.location.hostname

  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    import.meta.env.DEV
    ? `http://${hostname}:3000/php-api/${app}`
    : `https://api.noteplan.co/api/app/${app}`
}
